/*
=========================================================
* RingFoods Homepage Theme Helpers
=========================================================
*/

// Brand Colors - Sleek Black/White/Grey Palette
export const brandPrimary = "#1A1A1A"; // near black
export const brandSecondary = "#333333"; // dark grey

// Brand Gradient (primary to secondary)
export const brandGradient = `linear-gradient(135deg, ${brandPrimary} 0%, ${brandSecondary} 100%)`;

// Soft Backgrounds & Highlights
export const brandSoftGradient = `linear-gradient(135deg, rgba(26, 26, 26, 0.05) 0%, rgba(51, 51, 51, 0.05) 100%)`;
export const brandSoftRow = "rgba(26, 26, 26, 0.03)";

// Grey Shades - Clean neutral palette
export const grey100 = "#FAFAFA"; // very light background
export const grey200 = "#F5F5F5"; // light background
export const grey300 = "#E5E5E5"; // borders, icon boxes
export const grey400 = "#A3A3A3"; // disabled
export const grey500 = "#737373"; // placeholder
export const grey600 = "#525252"; // secondary text
export const grey700 = "#404040"; // body text
export const grey800 = "#262626"; // headings
export const grey900 = "#171717"; // dark text/backgrounds

// Accent Colors (subtle, professional)
export const accentSuccess = "#22C55E"; // green-500
export const accentInfo = "#3B82F6";    // blue-500
export const accentWarning = "#F59E0B"; // amber-500
export const accentError = "#EF4444";   // red-500

